import { Component } from '@angular/core';
import {RoutesTableComponent} from "./routes-table/routes-table.component";

@Component({
  selector: 'app-routes',
  imports: [RoutesTableComponent],
  templateUrl: './routes.component.html',
  styleUrl: './routes.component.scss',
})
export class RoutesComponent {}

